module.exports = __webpack_public_path__ + "static/media/Logo FarmaCon.b1d75417.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/Logo FarmaCon.jpg
// module id = 732
// module chunks = 0